import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dateField"]

  setToday() {
    const today = new Date().toISOString().slice(0, 10);
    this.dateFieldTarget.value = today;
  }
}